<script lang="ts" setup>
import LeButton from "@dsk/components/Button/LeButton.vue";
import { useI18n } from "vue-i18n";

import LeSectionHeading from "@/components/purchase/LeSectionHeading.vue";
import { useBackUrl } from "@/composables";

const { t } = useI18n();

const backUrl = useBackUrl();
</script>

<template>
  <div class="le-order-status-failure">
    <LeSectionHeading>
      {{ t("le-order-status-failure.heading") }}
    </LeSectionHeading>
    <p class="le-order-status-failure__text">{{ t("le-order-status-failure.text") }}</p>
    <LeButton tag="a" size="large" :href="backUrl" full-width>{{ t("le-order-status-failure.button-text") }}</LeButton>
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-order-status-failure {
  #media-breakpoint-up(lg, {
    max-width: 460px;
  });

  &__text {
    margin-top: 22px;
    margin-bottom: 48px;
    white-space: pre-line;
    .body-text("m");
  }
}
</style>
